<template>
    <layout title="Add User">
        <account :user="{}" :roles="roles"></account>
    </layout>
</template>


<script>
import Layout from '@/Shared/Layout'
import Account from '@/Components/Profile/Account'

export default {
    components: {
        Layout,
        Account,
    },
    metaInfo() {
        return {
            title: `Add New User`,
        }
    },
    props: {
        roles: Array,
    },
}
</script>
